import paymentData from "../data/payment";
import UserManager from "@/services/manager/UserManager";

function getPaymentData() {
  const role = UserManager.getRole();
  // Guard against null role (e.g. before login or corrupted localStorage)
  const key = role && role.includes("customer") ? "customer" : "supplier";

  return paymentData[key];
}

export default getPaymentData;
